module.exports = __webpack_public_path__ + "img/email.51a27e6d.svg";